import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { UserRoles } from "../../../constants/userRoles";
import { PrivateRoute } from "../../../keycloak";
import { LeadDetails } from "./LeadDetails/LeadDetails";
import { LeadEdit } from "./LeadEdit/LeadEdit";

export const LeadView = () => {
  const { leadId } = useParams<{ leadId: string }>();
  return (
    <Routes>
      <Route path="details">
        <Route
          element={
            <PrivateRoute
              roles={{
                dcs_client: [UserRoles.LEAD_UPDATE],
              }}
            />
          }
        >
          <Route path="edit" element={<LeadEdit leadId={leadId || ""} />} />
        </Route>
        <Route path="" element={<LeadDetails />} />
      </Route>
    </Routes>
  );
};
